import { memo, useContext } from 'react';
import { NavigateFunction } from 'react-router';

import { Button } from '@/components/old';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { ROUTES } from '../../../router/config';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './BirthdayUpdateAlert.scss';

export interface BirthdayUpdateAlertProps {
  navigate: NavigateFunction;
}

export const BirthdayUpdateAlert = memo(function BirthdayUpdateAlert({ navigate }: BirthdayUpdateAlertProps) {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.yellow}>
      <div className="birthday-alert">
        <div className="birthday-alert__title">Будь ласка, актуалізуйте свою дату народження у Вашому профілі</div>

        <div className="birthday-alert__buttons-box">
          <Button isBorder={true} isMaxWidth={true} onClick={(): void => toggleModal(false)}>
            Закрити
          </Button>

          <Button
            isMaxWidth={true}
            onClick={(): void => {
              navigate(ROUTES.USER.PROFILE);
              toggleModal(false);
            }}
          >
            Перейти у профіль
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
